// extracted by mini-css-extract-plugin
export var attachButton = "_iy-8";
export var sendButton = "_iy-2";
export var sendDisabled = "_iy-4";
export var sendEnabled = "_iy-3";
export var sendIcon = "_iy-6";
export var sendIconDisabled = "_iy-7";
export var sendStreaming = "_iy-5";
export var textarea = "_iy-1";
export var wrapper = "_iy-0";